import {memo} from 'react';

import {EllipsisTooltip} from '@macmillanplatform/ui-core';
import {formatDateMMDDYYY} from '@macmillanplatform/ui-core/utils';

import './index.css';

interface DateFormatterProps {
  date?: string;
}

const DateFormatter = (props: DateFormatterProps) => {
  const {date} = props;
  if (!date) return null;

  return (
    <EllipsisTooltip>
      <>{formatDateMMDDYYY(new Date(date))}</>
    </EllipsisTooltip>
  );
};

export default memo(DateFormatter);
